import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { CodeInline, Pdf, Table } from '@octopus-do/octopus-storybook/icons'
import { selectIsLoading } from '@store/loaders'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'

export const DownloadMenu: React.FC = () => {
  const loading = useSelector(selectIsLoading('report_export_pdf'))
  const { hasAccess: exportable } = useProjectAccess(
    EXPORT_PERMISSION.FILE_FORMATS
  )
  const ExportButton = exportable
    ? DropdownMenu.Button
    : DropdownMenu.BadgedButton

  return (
    <>
      <ExportButton
        type="pro"
        icon={Pdf}
        id="pdf"
        title="PDF report"
        disabled={loading}
      />
      <DropdownMenu.Button icon={CodeInline} id="sitemap" title="Sitemap.xml" />
      <ExportButton type="pro" icon={Table} id="csv" title="CSV" />
    </>
  )
}
